import React from 'react'
import { Box, Typography, Link } from '@mui/material'

interface ExploreOtherLink {
    text: string
    url: string
}

interface ExploreOtherLinksProps {
    title: string
    links: ExploreOtherLink[]
}

export const ExploreOtherLinks: React.FC<ExploreOtherLinksProps> = ({ title, links }) => {
    return (
        <Box sx={{ px: 3, py: 2 }}>
            <Typography
                variant="subtitle1"
                sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: '14px',
                    color: 'text.primary'
                }}
            >
                {title}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5
                }}
            >
                {links.map((link, index) => (
                    <Link
                        key={index}
                        href={link.url}
                        target="_parent"
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            fontSize: '12px',
                            '&:hover': {
                                color: 'primary.main',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {link.text}
                    </Link>
                ))}
            </Box>
        </Box>
    )
}

export type { ExploreOtherLinksProps }
